import { STORE_KEY as t, STORE_SUBKEY_IS_IN_CLIENT as o } from "@liff/consts";
import { isLIFFBrowser as e, isLINEBrowser as n } from "@liff/util";
var s = null;

function i() {
  return null === s && (s = e() || n() && /[#|&]access_token=/.test(location.hash) || "1" === sessionStorage.getItem(t + ":" + o), sessionStorage.setItem(t + ":" + o, s ? "1" : "0")), !!s;
}

function l() {
  s = null;
}

export { l as _cleanupCachedIsInClient, i as isInClient };